export enum HighlightFields {
    description = 'description',
    families = 'families',
    trigger = 'trigger',
    reported = 'reported',
    decorated = 'decorated',
    deprecated = 'deprecated',
}

export type HighlightAttributesItemInfo = {
    required: {actualValue: boolean, highlight: boolean},
    deprecated: {actualValue: boolean, highlight: boolean},
    description: {actualValue: string, highlight: boolean},
    possibleValues: {actualValue: string, highlight: boolean},
};

export type HighlightAttributesInfo = Record<string, HighlightAttributesItemInfo>;
